import { engineComponent } from "neo-common";
import { Communication, Platforms } from "neo-games";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { FreespinsUserControls } from "../Common/UserControls/FreespinsUserControls";
import { HtmlController } from "../../HTMLComponents/HtmlController";
import { GameManager } from "../../Managers/GameManager";
import { GameData } from "../Common/Datas/GameData";
import { DataManager } from "../../Managers/DataManager";
import { FreespinsController } from "../../GameComponents/Freespins/FreespinsController";
import { FreespinsActions } from "../Common/Actions/FreespinsActions";

@engineComponent(ComponentTypes.HtmlElement)
export class DesktopFreespinsUserControls extends FreespinsUserControls {
    constructor() {
        super("freespins");
    }

    create(node: Element): void {
        super.create(node);
    }

    addController(controller: FreespinsController): void {
        super.addController(controller);
        this._controller.on(FreespinsController.StartReceived, this.startReceived.bind(this));
        this._controller.on(FreespinsController.SpinReceived, this.spinReceived.bind(this));
        this._controller.on(FreespinsController.EndReceived, this.endReceived.bind(this));
        this._controller.on(FreespinsController.MachineStopped, this.machineStopped.bind(this));
        this._controller.on(FreespinsController.WinCalculationFinished, this.winCalculationFinished.bind(this));
        this._controller.on(FreespinsController.AllWinsFinished, this.allWinsFinished.bind(this));
        this._controller.on(FreespinsController.IntroFinished, this.introFinished.bind(this));
        this._controller.on(FreespinsController.OutroFinished, this.outroFinished.bind(this));
    }

    registerActions(): void {
        super.registerActions();
    }

    initReceived(): void {
        super.initReceived();
    }

    dispatchAction(action: string): void {
        super.dispatchAction(action);
    }

    machineStopped(): void {
        Platforms.Platforms.spinEnded();
        if (GameManager.freespinsResponse.currentWin === 0) {
            this._wasCalclulated = true;
        } else {
            this._wasCalclulated = false;
        }

        if (GameManager.freespinsResponse.currentWin > 0) {
            //this._afterWinDelay.start(30);

            let hasScatterFreespinWin = false;

            for (let i = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Scatter) {
                    if (GameManager.freespinsResponse.wins[i].type === Communication.Game.WinType.freeSpins) {
                        hasScatterFreespinWin = true;
                    }
                } else if (GameManager.freespinsResponse.wins[i].trigger === Communication.Game.WinTrigger.Way) {
                    if (GameManager.freespinsResponse.wins[i].type === Communication.Game.WinType.Cash) {
                    }
                }
            }

            if (hasScatterFreespinWin) {
                if (
                    GameManager.freespinsResponse.hasOwnProperty("customData") &&
                    GameManager.freespinsResponse.customData["wildMultiplier"] != null
                ) {
                    this._afterWinDelay.start(240);
                } else {
                    this._afterWinDelay.start(120);
                }
            } else {
                if (
                    GameManager.freespinsResponse.hasOwnProperty("customData") &&
                    GameManager.freespinsResponse.customData["wildMultiplier"] != null
                ) {
                    this._afterWinDelay.start(120);
                } else {
                    this._afterWinDelay.start(30);
                }
            }
        }

        if (this.isLastFreespin()) {
            this._afterWinDelay.stop();
            DataManager.Autoplay = false;
            this.actions.disableAllActions();
            if (GameManager.freespinsResponse.currentWin === 0) {
                if (GameManager.freespinsResponse.totalWin != null) {
                    DataManager.updateGameDataFromModule(
                        GameData.DataFreeSpinTotalWin,
                        GameManager.freespinsResponse.totalWin.toString(),
                    );
                }
                DataManager.updateDataElement(GameData.DataFreeSpinTotalWin);

                this._backButtonDelay.start(60);
            }
            HtmlController.updateActionElements(this.getAllActions());
            return;
        }

        this.actions.changeActionState(FreespinsActions.ActionSpinStop, false);

        if (GameManager.freespinsResponse.currentWin === 0) {
            this.prepareNewGameRound();
        }

        HtmlController.updateActionElements(this.getAllActions());

        if (DataManager.Autoplay && GameManager.freespinsResponse.currentWin === 0) {
            this._autoplayDelay.start(15);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Desktop/DesktopFreespinsUserControls.ts
 **/